/* GlobifySIM – Zielsuche mit Vorschlagsliste */
(function () {
  "use strict";

  var T = (window.GST || {});
  var SPRACHE = (document.documentElement.lang || "de").slice(0, 2).toLowerCase();

  function text(schluessel, ersatz) {
    return T[schluessel] || ersatz || "";
  }

  function name(ziel) {
    /* Reiseziele erscheinen immer auf Englisch */
    return ziel.en || ziel.de;
  }

  function flach(wert) {
    var t = String(wert == null ? "" : wert).toLowerCase();
    t = t.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss");
    if (t.normalize) t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return t.replace(/[^a-z0-9]+/g, " ").replace(/^ +| +$/g, "");
  }

  function ziele() {
    return window.GS_ZIELE || [];
  }

  function suchen(eingabe, grenze) {
    var q = flach(eingabe);
    if (!q) return [];
    var teile = q.split(" ").filter(Boolean);
    var treffer = [];
    ziele().forEach(function (z) {
      var heu = flach((z.de || "") + " " + (z.en || "") + " " + (z.such || ""));
      var punkte = 0;
      var name_flach = flach(name(z));
      if (name_flach === q) punkte = 100;
      else if (z.iso && flach(z.iso) === q) punkte = 95;
      else if (name_flach.indexOf(q) === 0) punkte = 80;
      else if (heu.split(" ").indexOf(q) >= 0) punkte = 85;
      else if (heu.indexOf(" " + q) >= 0 || heu.indexOf(q) === 0) punkte = 60;
      else if (heu.indexOf(q) >= 0) punkte = 40;
      else if (teile.length > 1 && teile.every(function (t) { return heu.indexOf(t) >= 0; })) punkte = 30;
      if (punkte) {
        if (z.beliebt) punkte += 5;
        treffer.push({ ziel: z, punkte: punkte });
      }
    });
    treffer.sort(function (a, b) {
      if (b.punkte !== a.punkte) return b.punkte - a.punkte;
      /* bei gleichem Rang zuerst das einzelne Land, dann das Mehrländerpaket */
      var pa = a.ziel.region === "paket" ? 1 : 0;
      var pb = b.ziel.region === "paket" ? 1 : 0;
      if (pa !== pb) return pa - pb;
      return name(a.ziel).localeCompare(name(b.ziel));
    });
    return treffer.slice(0, grenze || 8).map(function (t) { return t.ziel; });
  }

  /* Kategorien des Shops durchsuchen: "Europe", "Single country plans" ... */
  function kategorien(eingabe, grenze) {
    var q = flach(eingabe);
    if (!q) return [];
    var alle = window.GS_KATEGORIEN || [];
    var treffer = [];
    alle.forEach(function (k) {
      var name = flach(k.titel);
      var punkte = 0;
      if (name === q) punkte = 100;
      else if (name.indexOf(q) === 0) punkte = 78;
      else if (name.split(" ").indexOf(q) >= 0) punkte = 70;
      else if (name.indexOf(q) >= 0) punkte = 50;
      if (punkte) treffer.push({ kategorie: k, punkte: punkte });
    });
    treffer.sort(function (a, b) { return b.punkte - a.punkte; });
    return treffer.slice(0, grenze || 3).map(function (t) { return t.kategorie; });
  }

  function adresse(ziel, muster) {
    var basis = muster || "/products/";
    /* Produktseite: jedes Ziel entspricht genau einem Produkt aus dem Sortiment */
    if (basis.indexOf("/products") >= 0 && ziel.handle) {
      if (basis.charAt(basis.length - 1) !== "/") basis += "/";
      return basis + ziel.handle;
    }
    if (basis.indexOf("?") >= 0) return basis + encodeURIComponent(name(ziel));
    if (basis.charAt(basis.length - 1) !== "/") basis += "/";
    return basis + ziel.slug;
  }

  function aufbauen(wurzel) {
    var feld = wurzel.querySelector("[data-gs-such-feld]");
    var liste = wurzel.querySelector("[data-gs-vorschlaege]");
    var knopf = wurzel.querySelector("[data-gs-such-knopf]");
    var meldung = wurzel.querySelector("[data-gs-such-meldung]");
    if (!feld || !liste) return;
    var muster = wurzel.getAttribute("data-gs-ziel-link") || "/search?q=";
    var aktuell = [];
    var zeiger = -1;

    function schliessen() {
      liste.classList.remove("ist-offen");
      liste.innerHTML = "";
      zeiger = -1;
      feld.setAttribute("aria-expanded", "false");
    }

    function zeichnen(gefunden, kats) {
      liste.innerHTML = "";
      if (!gefunden.length && !(kats && kats.length)) { schliessen(); return; }
      gefunden.forEach(function (z, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "gs-vorschlag";
        b.setAttribute("role", "option");
        b.dataset.stelle = String(i);
        b.innerHTML = '<span class="gs-flagge">' + z.flagge + "</span><span>" + name(z) + "</span>";
        var e = document.createElement("em");
        e.textContent = z.iso || text("regional", "Regional");
        b.appendChild(e);
        b.addEventListener("click", function () { gehen(z); });
        liste.appendChild(b);
      });
      if (kats && kats.length) {
        var kopf = document.createElement("div");
        kopf.className = "gs-vorschlag__kopf";
        kopf.textContent = text("kategorien", "Categories");
        liste.appendChild(kopf);
        kats.forEach(function (k) {
          var a = document.createElement("a");
          a.className = "gs-vorschlag gs-vorschlag--kategorie";
          a.href = "/collections/" + k.handle;
          a.innerHTML = '<span class="gs-vorschlag__zeichen">&#9635;</span><span>' + k.titel + "</span>";
          var e = document.createElement("em");
          e.textContent = k.anzahl;
          a.appendChild(e);
          liste.appendChild(a);
        });
      }

      liste.classList.add("ist-offen");
      feld.setAttribute("aria-expanded", "true");
    }

    function markieren() {
      var alle = liste.querySelectorAll(".gs-vorschlag");
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.toggle("ist-aktiv", i === zeiger);
      }
      if (zeiger >= 0 && alle[zeiger]) alle[zeiger].scrollIntoView({ block: "nearest" });
    }

    function gehen(ziel) {
      window.location.href = adresse(ziel, muster);
    }

    function absenden() {
      var wert = feld.value.trim();
      if (!wert) {
        if (meldung) meldung.textContent = text("leer", "Please enter a destination.");
        feld.focus();
        return;
      }
      if (aktuell.length) { gehen(aktuell[zeiger >= 0 ? zeiger : 0]); return; }
      var kats = kategorien(wert, 1);
      if (kats.length) { window.location.href = "/collections/" + kats[0].handle; return; }
      if (meldung) meldung.textContent = text("kein_treffer", "");
      window.location.href = (muster.indexOf("?") >= 0 ? muster : "/search?q=") + encodeURIComponent(wert);
    }

    feld.addEventListener("input", function () {
      if (meldung) meldung.textContent = "";
      aktuell = suchen(feld.value, 6);
      zeichnen(aktuell, kategorien(feld.value, 3));
    });

    feld.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); zeiger = Math.min(zeiger + 1, aktuell.length - 1); markieren(); }
      else if (e.key === "ArrowUp") { e.preventDefault(); zeiger = Math.max(zeiger - 1, -1); markieren(); }
      else if (e.key === "Enter") { e.preventDefault(); absenden(); }
      else if (e.key === "Escape") { schliessen(); }
    });

    feld.addEventListener("blur", function () { window.setTimeout(schliessen, 160); });

    if (knopf) knopf.addEventListener("click", function (e) { e.preventDefault(); absenden(); });
  }

  window.GSSuche = { suchen: suchen, adresse: adresse, name: name, flach: flach, kategorien: kategorien };

  document.addEventListener("DOMContentLoaded", function () {
    var alle = document.querySelectorAll("[data-gs-suche]");
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  });
})();
